import type { BoxProps, ContainerProps, StackProps } from '@mui/material'
class DetailStyle {
  static Container: ContainerProps = {
    maxWidth: false,
    disableGutters: true,
    sx: {
      display: 'flex',
      padding: 2,
      gap: '1rem',
      flexDirection: 'column'
    }
  }

  static Stack: StackProps = {
    direction: 'column',
    spacing: 2
  }

  static ImageBox: BoxProps = {
    height: '300px',
    border: '1px solid #eee',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  }
}

export default DetailStyle
